// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomToast_wrapper__mZDQ3","text":"CustomToast_text__wBJOX","btn":"CustomToast_btn__xfNtL","toast_body":"CustomToast_toast_body__cpJ0V"};